const { RECOMMENDATIONS_CONTEXT } = require('../constants');

const buildQueryObject = (sourcePage, componentName, extraParams = {}) => ({
    context: RECOMMENDATIONS_CONTEXT,
    context_referrer: sourcePage,
    source: componentName,
    ...extraParams,
});

module.exports = {
    buildQueryObject,
};
